export default {"src":"/_next/static/media/clp-blue-beige-pattern-breezy.5c4fa7dc.svg","height":200,"width":1439,"blurWidth":0,"blurHeight":0};